import { Injectable } from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, of, throwError } from 'rxjs'
import { tap, catchError, take } from 'rxjs/operators'
import { Router } from '@angular/router'
import { SessionService } from './session.service'
import { TokenService } from './token.service'
import { UserDataService } from './shared/user-data.service'

@Injectable({
  providedIn: 'root',
})
export class ResponseInterceptorService implements HttpInterceptor {
  private userData: any

  constructor(
    private router: Router,
    private session: SessionService,
    private userDataService: UserDataService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any, caught) => {
        if (error.status == 503) {
          this.router.navigateByUrl('/maintanance')
          return
        }
        if (
          error.status == 401
          // && !this.tokenService.isValid()
        ) {
          this.session.set('url', this.router.url)

          if (this.router.url.includes('department')) {
            this.router.navigateByUrl('/auth/adelphi')
            return
          }

          if (this.router.url.includes('auth')) {
            this.router.navigateByUrl(this.router.url)
          } else {
            if (this.userData) {
              this.redirect(this.userData)
            } else {
              this.userDataService.userData$.pipe(take(1)).subscribe((data) => {
                this.userData = data
                this.redirect(data)
              })
            }
          }
        }
        return throwError(() => error)
      })
    )
  }

  private redirect(data: any) {
    const targetUrl =
      data.user.role === 'vendor_admin'
        ? '/auth/' + data.company_short_name
        : '/login'
    if (this.router.url === targetUrl) return
    this.router.navigateByUrl(targetUrl)
  }
}
